import { DropDown, requiredRule, ValidatedDropDownList, ValidatedInput } from "@finbeat/react-toolkit";
import { ClientWithdrawOrder } from "models/api/client";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ClientWithdrawMoneyModalFormType } from "./ClientWithdrawMoneyModal";

type ClientWithdrawMoneyFormProps = {
    orders: ClientWithdrawOrder[];
    ordersIsFetching: boolean;
    isLoading: boolean;
    waitPaymentResult: boolean;
};

const ClientWithdrawMoneyForm = ({ orders, ordersIsFetching, isLoading, waitPaymentResult }: ClientWithdrawMoneyFormProps) => {
    const { t } = useTranslation();

    const { watch } = useFormContext<ClientWithdrawMoneyModalFormType>();
    const orderId = watch('orderId');

    const ordersDropDown = useMemo(
        () => (orders.map((o) => {
            return {
                id: o.id,
                name: `#${o.id}`,
            } as DropDown;
        })),
        [orders]
    );

    const withdrawAmountRule = (val: number) => {
        const amountMinValue = 1000;
        const amountMaxValue = orders.find(o => o.id === orderId)?.loanFullDebtAmount ?? null

        if (val < amountMinValue)
            return t('BackOfficeGreaterThanValidator', { ComparisonValue: amountMinValue.toString() });
        if (amountMaxValue !== null && val > amountMaxValue) {
            return t('BackOfficeDebtBalanceValidator', { ComparisonValue: amountMaxValue.toString() });
        }
        return true;
    }

    return (
        <>
            <ValidatedDropDownList<ClientWithdrawMoneyModalFormType>
                name="orderId"
                label={t('BackOfficeSelectOrder')}
                items={ordersDropDown}
                isLoading={ordersIsFetching}
                disabled={!ordersDropDown.length || isLoading || waitPaymentResult}
                rules={{
                    required: requiredRule,
                }}
            />
            <ValidatedInput<ClientWithdrawMoneyModalFormType>
                name="amount"
                type="number"
                label={t('BackOfficeAmount')}
                rules={{
                    required: requiredRule,
                    validate: withdrawAmountRule
                }}
                disabled={!orders.length || isLoading || waitPaymentResult}
                step={0.01}
            />
        </>
    );
};

export default ClientWithdrawMoneyForm;
